import { render } from "./CategorySelector.vue?vue&type=template&id=042507dd&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"

import "./CategorySelector.vue?vue&type=style&index=0&id=042507dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042507dd"]])

export default __exports__